import { render } from "./manage-customer-progress-item.vue?vue&type=template&id=28af861d"
import script from "./manage-customer-progress-item.vue?vue&type=script&lang=js"
export * from "./manage-customer-progress-item.vue?vue&type=script&lang=js"
script.render = render

export default script